/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import CookieBanner from '@pmirau/cookie-banner';

import Header from "./header"
import Footer from "./footer";
import "./layout.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title}/>
      <main>
        {children}
      </main>
      <Footer data={data} />
      <CookieBanner
        infoText="Diese Internetseite verwendet Cookies, um Ihnen bestmögliche Funktionalität bieten zu können."
        link={{
          href: '/datenschutz',
          text: 'Zur Datenschutzerklärung'
        }}
        buttonText="Akzeptieren"
        styles={{
          link: {
            normalColor: '#c8d58d'
          }
        }}
      />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
